import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import { Helmet } from "react-helmet";
import Header from "../../components/header";
import Footer from "../../components/footer";
import CardLeftRight from "../../components/cardleftright";
import { dataListsType } from "../../shared/type";
import AdPage from "../../components/AdPage";
import { DataLists } from "../../dataLists/DataLists";

import { HelmetSeo } from "../../components/HelmetSeo";

interface HotelSectionProps {
  hotelsData: dataListsType[];
  nation: string;
}

const HotelSection = ({ nation, hotelsData }: HotelSectionProps) => (
  <div className="w-full mb-16 px-8">
    <div className="mb-8 border-b-[1px]">
      <h5 className="uppercase text-sm font-semibold pt-2 pb-2 tracking-wider flex justify-between">
        <span>
          <b className="text-[#181818]">{nation}</b> Hotels
        </span>

        <Link
          className="font-bold text-[#c9b077]"
          to={{
            pathname: "/morepage",
            search: `?category=Hotels&nation=${encodeURIComponent(
              nation,
            )}&label=${encodeURIComponent(`${nation} Hotels`)}`,
          }}
        >
          MORE{">>"}
        </Link>
      </h5>
      <span className="block w-16 h-[3px] bg-[#c9b077]"></span>
    </div>
    <div className="w-full flex flex-col gap-y-10">
      <CardLeftRight
        props={hotelsData.sort(() => Math.random() - 0.5).slice(0, 8)}
      />
    </div>
  </div>
);

export default function Hotels() {
  const [hotelsData, setHotelsData] = useState<{
    Indonesia: dataListsType[];
    China: dataListsType[];
    Japan: dataListsType[];
    Global: dataListsType[];
    India: dataListsType[];
    Laos: dataListsType[];
    Thailand: dataListsType[];
    // Singapore: dataListsType[];
  }>({
    Indonesia: [],
    China: [],
    Japan: [],
    Global: [],
    India: [],
    Laos: [],
    Thailand: [],
    // Singapore: [],
  });

  useEffect(() => {
    const allData = DataLists.filter((item) => item.category === "Hotels");
    setHotelsData({
      // Singapore: allData.filter((item) => item.nation === "Singapore"),
      Indonesia: allData.filter((item) => item.nation === "Indonesia"),
      Japan: allData.filter((item) => item.nation === "Japan"),
      China: allData.filter((item) => item.nation === "China"),
      Global: allData.filter((item) => item.nation === "Global"),
      India: allData.filter((item) => item.nation === "India"),
      Laos: allData.filter((item) => item.nation === "Laos"),
      Thailand: allData.filter((item) => item.nation === "Thailand"),
    });
  }, []);

  return (
    <>
      <HelmetSeo
        title="Hotels in Asia - Find Best Accommodations & Places to Stay"
        description="Find the perfect accommodation in Asia, from luxury hotels to budget-friendly stays in China, Japan, Indonesia and more. Detailed reviews and booking guides."
        ogType="website"
      />
      <Header />

      <AdPage />
      <div className="w-full h-full fixed top-0 left-0 -z-10 bg-white/60 bg-blend-overlay backdrop-blur-md"></div>
      {/* <Helmet>
        <title>
          Hotels in Asia - Find Best Accommodations & Places to Stay
        </title>
        <meta
          name="description"
          content="Find the perfect accommodation in Asia, from luxury hotels to budget-friendly stays in China, Japan, Indonesia and more. Detailed reviews and booking guides."
        />
      </Helmet> */}

      <div className="w-full flex justify-center">
        <div className="flex flex-col justify-center 2xl:max-w-[1500px] max-w-[1200px] my-8">
          <h1 className="text-3xl font-extrabold px-8 pb-3">Hotels</h1>
          {Object.entries(hotelsData).map(([nation, data]) => (
            <HotelSection key={nation} nation={nation} hotelsData={data} />
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
